export const builder_supportedSoftwareCarousel = (): void => {
  const builder_supportedSoftware_components = document.querySelectorAll('.js-builder_supportedSoftware') as unknown as HTMLElement[]

  const bodyElement = document.querySelector('body') as unknown as HTMLElement

  if (!builder_supportedSoftware_components || !bodyElement) {
    return
  }

  builder_supportedSoftware_components.forEach(achivement => {
    const builder_supportedSoftware_wrapper = achivement.querySelector('.js-builder_supportedSoftware-wrapper') as unknown as HTMLElement
    const achievmentsInner = achivement.querySelector('.js-builder_supportedSoftware-inner') as unknown as HTMLElement

    const localStyleElement = achivement.querySelector('.js-style') as unknown as HTMLElement

    const localID = achivement.dataset.special_id

    const allLocalElems = achivement.querySelectorAll('.js-builder_supportedSoftware-single') as unknown as HTMLElement[]

    if (allLocalElems.length === 0) {
      return
    }

    let previousWidth = 0

    const checkCarouselSizing = () => {
      let localWidth = 0

      allLocalElems.forEach(icon => {
        const iconMarginLeft = parseInt(getComputedStyle(icon).marginLeft)
        const iconMarginRight = parseInt(getComputedStyle(icon).marginRight)

        localWidth += icon.offsetWidth + iconMarginLeft + iconMarginRight
      })

      if (window.innerWidth >= localWidth / 2) {
        achievmentsInner.classList.add('-maxSized')
      } else {
        achievmentsInner.classList.remove('-maxSized')
      }

      if (localWidth === previousWidth) {
        return
      }

      previousWidth = localWidth

      const supportedSoftware_2022Style = `
      @keyframes scroll-builder_supportedSoftware-${localID} {

        100% {
          transform: translateX(calc(-${(localWidth / 2)}px));
        }
      }
    `

      localStyleElement.innerHTML = supportedSoftware_2022Style

      builder_supportedSoftware_wrapper.style.width = `${localWidth / 2}px`
      achievmentsInner.style.width = `${localWidth}px`
      achievmentsInner.style.animation = `${localWidth / 2 / 100}s linear 0s infinite normal none running scroll-builder_supportedSoftware-${localID}`
    }

    // On resize
    window.addEventListener('resize', () => {
      checkCarouselSizing()
    })

    setInterval(() => {
      // checkCarouselSizing()
    }, 250)

    checkCarouselSizing()
  })
}
